import { styled } from '@mui/material/styles';
import { FormControlLabel, Switch, SwitchProps } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';

interface IIosSwitch {
	label?: string;
	checked?: boolean;
	setValue?: Dispatch<SetStateAction<boolean>>;
	name?: string;
	defaultChecked?: boolean;
	inputRef?: any;
}

const IosSwitch: React.FC<IIosSwitch & SwitchProps> = ({ label, name, inputRef, defaultChecked, checked, setValue = () => {}, ...props }) => {
	const IOSSwitch = styled((props: SwitchProps) => <Switch inputRef={inputRef} {...props} />)(({ theme }) => ({
		width: 44,
		height: 26,
		padding: 0,
		'& .MuiSwitch-switchBase': {
			padding: 0,
			margin: 2,
			transitionDuration: '300ms',
			'&.Mui-checked': {
				transform: 'translateX(18px)',
				color: '#fff',
				'& + .MuiSwitch-track': {
					backgroundColor: props.color ?? theme.palette.primary.main,
					opacity: 1,
					border: 0,
				},
				'&.Mui-disabled + .MuiSwitch-track': {
					opacity: 0.5,
				},
			},
			'&.Mui-focusVisible .MuiSwitch-thumb': {
				color: props.color ?? theme.palette.primary.main,
				border: '6px solid #fff',
			},
			'&.Mui-disabled .MuiSwitch-thumb': {
				color: theme.palette.grey[100],
			},
			'&.Mui-disabled + .MuiSwitch-track': {
				opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
			},
		},
		'& .MuiSwitch-thumb': {
			boxSizing: 'border-box',
			width: 22,
			height: 22,
		},
		'& .MuiSwitch-track': {
			borderRadius: 26 / 2,
			backgroundColor: theme.palette.grey[300],
			opacity: 1,
			transition: theme.transitions.create(['background-color'], {
				duration: 500,
			}),
		},
	}));

	const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setValue(event.target.checked);
	};

	return <FormControlLabel control={<IOSSwitch sx={{ m: 1 }} color="success" checked={checked} defaultChecked={defaultChecked} onChange={handleSwitchChange} />} label={label} />;
};

export default IosSwitch;
